import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
//import xor from 'lodash.xor';

import WP from 'WP';
import api from 'api';
import Container from 'partials/Container';
import grid2 from 'images/grid2.svg';
import grid4 from 'images/grid4.svg';
import close from 'images/close.svg';
import css from 'css';

class Filters extends Component {

    constructor() {
        super();

        this.state = {
            filters: [],
            gridType: 2,
            active: [WP.trans.all],
            mobileFiltersOpen: false,
        }

    }

    componentWillMount() {
        this.mounted = true;

        if(!window.location.hash) {
            window.location.hash = [WP.trans.all];
        }

        api.getTerms(this.props.taxonomy)
            .then(resp => {
                if(resp.data[0]) {
                    const terms = resp.data.map(term => term.name);
                    let filterValues = [WP.trans.all, ...terms];

                    // additional filter value for projects
                    //if(this.props.taxonomy === 'types') {
                        //filterValues = [WP.trans.all, WP.trans.selected, ...terms];
                    //}

                    const hash = decodeURIComponent(window.location.hash.substring(1));
                    let active = [WP.trans.all];
                    if(filterValues.indexOf(hash) !== -1) {
                        active = [hash];
                        if(typeof this.props.onFilter === 'function')
                            this.props.onFilter(active);
                    }

                    if(this.mounted) {
                        this.setState({ 
                            filters: filterValues,
                            active: active
                        });
                    }
                }
            })
            .catch(e => console.log('could not load terms', e));

        window.addEventListener('resize', this._onResize.bind(this));
    }

    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener('resize', this._onResize.bind(this));
    }

    _onResize() {
        if(window.outerWidth < 980 && this.state.gridType === 4) {
            this.setState({ gridType: 2 });
        } 
    }

    _onFilter(name) {
        //let activeFilters = name === WP.trans.all ? [name] : xor(this.state.active, [name]).filter(name => name !== WP.trans.all);
        let activeFilters = [name];

        window.location.hash = name;

        //if(activeFilters.length === 0)
        //    activeFilters = [WP.trans.all];
        
        this.setState({ 
            active: activeFilters,
            mobileFiltersOpen: false
        });
        
        if(typeof this.props.onFilter === 'function')
            this.props.onFilter(activeFilters);
    }

    _toggleGrid() {
        this.setState({
            gridType: this.state.gridType === 2 ? 4 : 2
        }, () => {
            this.props.onGridToggle(this.state.gridType);
        });
    }

    _toggleMobileFilters() {
        this.setState({ mobileFiltersOpen: !this.state.mobileFiltersOpen });
    }

    render() {
        const { title, onGridToggle, background } = this.props;
        const { filters, active, gridType, mobileFiltersOpen } = this.state;
        return (
            <Wrapper background={background}>
                <Container>
                    <h1>{title}</h1>
                    <nav aria-label="filter" className={mobileFiltersOpen ? 'open' : ''}>
                        <span>Filter:</span>
                        {filters.map((item, i) => {
                            return <FilterLink 
                                    key={i} 
                                    className={active.indexOf(item) !== -1 ? 'active' : ''}
                                    onClick={() => this._onFilter.bind(this)(item)} 
                                    aria-label={'filter: '+item} 
                                    first={i === 0}
                                    >
                                    {item}
                                    </FilterLink>
                        })}

                        <button className="close-filters" onClick={this._toggleMobileFilters.bind(this)}>
                            <img src={WP.assets+close} alt="Close filters"/>
                        </button>

                        <button className="open-filters" onClick={this._toggleMobileFilters.bind(this)}>
                            Filter
                        </button>

                        {typeof onGridToggle === 'function' &&
                            <button className="grid-toggle" onClick={this._toggleGrid.bind(this)}>
                                <img src={gridType === 4 ? WP.assets+grid2 : WP.assets+grid4} alt="grid toggle" />
                            </button>
                        }

                    </nav>

                    {active.indexOf(WP.trans.all) === -1 &&
                        <ActiveFiltersMobileIndicator>
                            <span>{WP.trans.activeFilters}</span>
                            {active.map((item, i) => <span key={i}>{item}</span> )}
                        </ActiveFiltersMobileIndicator>
                    }
                </Container>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => {
    return {
        currentView: state.currentView
    }
}

export default connect(mapStateToProps, null)(Filters);

const Wrapper = styled.div`
    padding: 60px 0;
    background-color: ${props => props.background === 'white' ? '#fff' : css.colors.gray};
    @media (max-width: 768px) {
        padding: 20px 0 20px;
    }
    > div {
        display:flex;
        flex-wrap: wrap;
        justify-content: space-between;
        h1 {
            font-size:24px;
            flex:1 0 auto;
            font-family: ${css.fonts.bg_bold};
            @media (max-width: 768px) {
                margin-bottom:15px;
            }
        }
        nav {
            font-size:14px;
            font-family: ${css.fonts.bg_regular};
            flex:1 0 auto;
            position:relative;
            padding-right:30px;
            @media (max-width: 980px) {
                padding-right:0;
            }
            max-width: ${css.sizes.rightColumn};

            .close-filters {
                display:none;
            }

            .open-filters {
                display:none;
                cursor:pointer;
            }

            span {
                font-size:14px;
                color:#797979;
                margin-bottom: 10px;
                margin-right:20px;
                @media (max-width: 768px) {
                    display:block; 
                    margin-bottom:20px;
                    font-size:18px;
                }
            }

            button.grid-toggle {
                position:absolute;
                top:0;
                right:0;
                cursor:pointer;
                @media (max-width: 980px) {
                    display:none;
                }
                img {
                    width:22px;
                    height: 22px;
                }
            }
            
            @media (max-width: 768px) {

                justify-content: flex-end;
                display: flex;
                align-items: flex-start;

                button, span {
                    display:none;
                }

                .open-filters {
                    display:inline-block;
                    margin-top:5px;
                    font-size:18px;
                }

                &.open {
                    position: fixed;
                    width: 100%;
                    max-width: 100%;
                    height: 100%;
                    background: #F8F8F8;
                    top: 0;
                    left: 0;
                    z-index: 900;
                    padding: 25px;
                    overflow-y:auto;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    align-items: flex-start;

                    button, span {
                        display: inline-block;
                    }

                    .close-filters {
                        display: inline-block;
                        position: absolute;
                        top: 25px;
                        right: 25px;
                        cursor: pointer;
                    }

                    .open-filters, .grid-toggle {
                        display:none;
                    }
                }
            }
        }
    }
`

const FilterLink = styled.button`
    display:inline-block;
    margin-right:20px;
    margin-bottom:10px;
    cursor:pointer;
    border-bottom: 1px solid transparent;
    padding-bottom: 2px;
    &:hover, &.active {
        border-bottom: 1px solid #000;
        padding-bottom: 2px;
    }
    @media (max-width: 768px) {
        margin-bottom:20px;
        font-size: 18px;
        &:hover {
            font-size:18px;
        }
    }
`

const ActiveFiltersMobileIndicator = styled.div`
    display:none;
    width:100%;
    color: #797979;
    font-size:14px;
    span {
        display:inline-block;
        margin-right: 10px;
        margin-bottom: 10px;
        &:after {
            content: ',';
        }
        &:first-child:after {
            display:none;
        }
        &:last-child:after {
            display:none;
        }
    }
    @media (max-width: 768px) {
        display:block;
    }
`


// WEBPACK FOOTER //
// ./src/partials/Filters.js